export default __webpack_public_path__ + "static/media/ic-player-back.a2682e27.svg";